import { sliderSettings } from "../../../components/Slider";
import Slider from "react-slick";
import { Box, makeStyles } from "@material-ui/core";
import { QuoteLineItem } from "../../../api/Quote/QuoteLineItem";

const QuoteTopSlider = ({ lineItems }: Props) => {
  const classes = useStyles();

  if (lineItems === null) {
    return null;
  }

  const slideRender = function (item: QuoteLineItem) {
    if (item === null || item.imageUrl === null) {
      return null;
    }

    return (
      <Box key={item.productId}>
        <img alt={item.name} src={item.imageUrl} />
      </Box>
    );
  };

  return (
    <Box boxShadow={1}>
      <Slider {...sliderSettings} autoplay={true} autoplaySpeed={8000} className={classes.imageSlider}>
        {lineItems.map((li) => slideRender(li))}
      </Slider>
    </Box>
  );
};

export default QuoteTopSlider;

const useStyles = makeStyles((theme) => ({
  imageSlider: {
    "& .slick-dots li button:before": {
      fontSize: theme.typography.caption
    },
    "& .slick-slide img": {
      maxHeight: "420px",
      margin: "auto",
      maxWidth: "300px",
      marginBottom: theme.spacing(3),
      marginTop: theme.spacing(3),
      [theme.breakpoints.down("md")]: {
        maxHeight: "320px",
        maxWidth: "220px"
      }
    },
    "& .slick-next, & .slick-prev": {
      display: "none !important"
    }
  }
}));

interface Props {
  lineItems: QuoteLineItem[] | null;
}
